const config = {
  siteTitle: 'ELE Barcelona', // Site title.
  siteTitleShort: 'elebarcelona', // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: 'elebarcelona', // Alternative site title for SEO.
  siteLogo: 'src/assets/images/favicon/favicon.jpeg', // Logo used for SEO and manifest.
  siteFavicon: 'src/assets/images/favicon/favicon.jpeg',
  siteImage: 'https://devhance.co/images/photos/devhance.png',
  siteUrl: 'https://elebarcelona.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: 'ELE Barcelona', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteRssTitle: '', // Title of the RSS feed
  siteFBAppID: '', // FB Application ID for using app insights
  googleAnalyticsID: 'UA-55402851-1', // GA tracking ID.
  dateFromFormat: 'YYYY-MM-DD', // Date format used in the frontmatter.
  dateFormat: 'DD/MM/YYYY', // Date format for display.
  userName: 'Devhance Team', // Username to display in the author segment.
  userEmail: 'hello@devhance.co', // Email used for RSS feed's author segment
  userTwitter: '@devhance_co', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Spain, Barcelona', // User location to display in the author segment.
  userAvatar: 'src/assets/images/favicon/favicon.jpeg', // User avatar to display in the author segment.
  userDescription: '', // User description to display in the author segment.
  themeColor: '#3eb5f1', // Used for setting manifest and progress theme colors.
  backgroundColor: '#3eb5f1', // Used for setting manifest background color.
  copyright: 'Copyright © Devhance 2021. All rights reserved.', // Copyright string for the footer of the website and RSS feed.,
  locale: 'es',
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = '';
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/') config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/') config.siteRss = `/${config.siteRss}`;

module.exports = config;
